@if (showQuantity) {
  @if (focused) {
    <button
      [attr.aria-label]="'aimo.product.decreaseQuantity' | cxTranslate"
      [ngbPopover]="readonly ? '' : ('aimo.product.decreaseQuantity' | cxTranslate)"
      container="body"
      triggers="mouseenter:mouseleave"
      popoverClass="popover-default popover-hide-mobile"
      (keydown.enter)="enterPressed($event)"
      [ngClass]="buttonsClass ? buttonsClass : 'button-decrease'"
      type="button"
      (click)="cancelEvent()">
      <i class="aimo-icon icon-sm icon-x"></i>
    </button>
  }
  @if (!focused) {
    <button
      [attr.aria-label]="'aimo.product.decreaseQuantity' | cxTranslate"
      [ngbPopover]="readonly ? '' : ('aimo.product.decreaseQuantity' | cxTranslate)"
      container="body"
      triggers="mouseenter:mouseleave"
      popoverClass="popover-default popover-hide-mobile"
      (keydown.enter)="enterPressed($event)"
      [ngClass]="buttonsClass ? buttonsClass : 'button-decrease'"
      class="btn-minus"
      type="button"
      (click)="decrementEvent($event)"
      [disabled]="qtyFormField.disabled || (min && qtyFormField.value <= min) || readonly"
      [tabindex]="qtyFormField.disabled || qtyFormField.value <= min ? -1 : 0">
      <i
        class="aimo-icon icon-sm icon-minus-bold"
            [ngClass]="[
                showSpinner && (isOpenedSpinner$ | async) && isOpenedLocalSpinner() && !isPLP ? 'icon-white' : '',
                showSpinner && (isOpenedSpinner$ | async) && isPLP ? 'd-none' : '',
            ]"></i>
    </button>
  }
  @if (parentForm) {
    <ng-container [formGroup]="parentForm">
      <ng-container [formArrayName]="parentFormArrayName">
        <ng-container [formArrayName]="parentFormGroupName">
          <ng-container *ngTemplateOutlet="inputField"></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  }
  @if (!parentForm) {
    <ng-container *ngTemplateOutlet="inputField"></ng-container>
  }
  @if (focused) {
    <button
      #increaseButton
      [attr.aria-label]="'aimo.product.increaseQuantity' | cxTranslate"
      [ngbPopover]="readonly ? '' : ('aimo.product.increaseQuantity' | cxTranslate)"
      container="body"
      triggers="mouseenter:mouseleave"
      popoverClass="popover-default popover-hide-mobile"
      placement="top"
      (keydown.enter)="enterPressed($event)"
      [ngClass]="buttonsClass ? buttonsClass : 'button-increase'"
      type="button"
      (click)="enterPressed($event)"
      [disabled]="qtyFormField.disabled || readonly"
      tabindex="0">
      <i class="aimo-icon icon-sm icon-check"></i>
    </button>
  }
  @if (!focused) {
    <button
      #increaseButton
      [attr.aria-label]="'aimo.product.increaseQuantity' | cxTranslate"
      [ngbPopover]="readonly ? '' : ('aimo.product.increaseQuantity' | cxTranslate)"
      container="body"
      (keydown.enter)="enterPressed($event)"
      triggers="mouseenter:mouseleave"
      popoverClass="popover-default popover-hide-mobile"
      placement="top"
      [ngClass]="buttonsClass ? buttonsClass : 'button-increase'"
      type="button"
      (click)="incrementEvent($event, true)"
      [disabled]="qtyFormField.disabled || (max && qtyFormField.value >= max) || readonly"
      tabindex="0">
      <i
        class="aimo-icon icon-sm icon-plus-bold"
            [ngClass]="[
                showSpinner && (isOpenedSpinner$ | async) && isOpenedLocalSpinner() && !isPLP ? 'icon-white' : '',
                showSpinner && (isOpenedSpinner$ | async) && isPLP ? 'd-none' : '',
            ]"></i>
      @if (showSpinner) {
        <div #spinnerDiv class="d-none spinner">
          <aimo-spinner
            class="spinner-xsm"
            [ngClass]="buttonsClass ? 'spinner-white' : ''"
          [isModal]="false"></aimo-spinner>
        </div>
      }
    </button>
  }
}

@if (!showQuantity) {
  <button
    #increaseButton
    (click)="incrementEvent($event, true, true, true)"
    class="btn btn-primary btn-icon btn-add-to-cart noPrint"
    type="submit"
    [attr.aria-label]="'addToCart.addToCart' | cxTranslate: { name: product?.name }"
    [ngbPopover]="readonly ? '' : ('addToCart.addToCart' | cxTranslate: { name: product?.name })"
    container="body"
    triggers="mouseenter:mouseleave"
    popoverClass="popover-default"
    placement="top"
    (keydown.enter)="enterPressed($event)"
    [disabled]="readonly">
    <i class="aimo-icon icon-white icon-shopping-cart-simple icon-sm noPrint" #iconCart></i>
    @if (qtyShown > 0) {
      <i class="available-qty noPrint">{{ qtyShown }}</i>
    }
  </button>
}

<ng-template #inputField>
  <div class="cx-amount" (click)="onClick()">
    <input
      [attr.aria-label]="'aimo.product.inputQuantity' | cxTranslate: { name: product?.name }"
      #qtyInput
      type="number"
      [id]="id"
      [min]="min"
      [max]="max"
      [readonly]="readonly"
      [tabindex]="readonly ? -1 : 0"
      [formControl]="qtyFormField"
      (ngModelChange)="inputChanged($event, qtyInput, false)"
      (change)="inputChanged($event, qtyInput, true)"
      (keydown.enter)="enterPressed($event)"
      (keydown)="changeCommaToDot($event)"
      (blur)="onBlur($event)"
      class="aimo-input" />
      @if (unitName) {
        <span>{{ unitName | lowercase }}</span>
      }
    </div>
  </ng-template>
